import * as i0 from '@angular/core';
import { Injectable, Component, NgModule } from '@angular/core';
import { map, take } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import * as i1$1 from '@angular/forms';
import { Validators, ReactiveFormsModule } from '@angular/forms';
import * as errorUtils from 'error-message-utility';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject, combineLatest } from 'rxjs';
import { getSubTaskDetails, getStepDetails, updateStepStatus } from 'visa-store';
import * as i6 from '@ngrx/store';
import { select } from '@ngrx/store';
import { map as map$1 } from 'rxjs/internal/operators/map';
import { MarkDirtyFormAction, MarkCleanFormAction } from 'dirty-check-store';
import * as i2 from 'base-consulate-address-library';
import * as i4 from 'primeng/dynamicdialog';
import * as i5 from 'ngx-toastr';
import * as i7 from 'step-status-update-payload-service';
import * as i8 from 'cache-country-list';
import * as i9 from 'reference-library';
import * as i10 from 'primeng/dropdown';
import * as i11 from '@angular/common';
import * as i12 from 'primeng/inputtext';
import * as i13 from 'primeng/button';
import { PrimengLibraryModule } from 'primeng-library';

class PortOfEntryLibraryService {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    getPort(visaType, caseType, caseId) {
        // v1/TN1/PETITION/367/portOfEntry
        return this.httpClient.get(`/${visaType}/${caseType}/${caseId}/portOfEntry`).pipe(map((response) => {
            if (response.status === 200 || response.status === 204) {
                return response;
            }
        }));
    }
    savePort(visaType, caseType, caseId, payload) {
        // TN1/PETITION/367/portOfEntry
        return this.httpClient.post(`/${visaType}/${caseType}/${caseId}/portOfEntry`, payload).pipe(map((response) => {
            if (response.status === 200 || response.status === 204) {
                return response;
            }
        }));
    }
    getStates(countryCode) {
        return this.httpClient.get(`/countries/states?countryCode=${countryCode}`).pipe(map((response) => {
            if (response.status) {
                return response.data;
            }
        }));
    }
}
PortOfEntryLibraryService.ɵfac = function PortOfEntryLibraryService_Factory(t) { return new (t || PortOfEntryLibraryService)(i0.ɵɵinject(i1.HttpClient)); };
PortOfEntryLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: PortOfEntryLibraryService, factory: PortOfEntryLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PortOfEntryLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

function PortOfEntryLibraryComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.getGlobalErrorMessages("REQUIRED"), " ");
} }
function PortOfEntryLibraryComponent_span_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 23);
} }
function PortOfEntryLibraryComponent_p_dropdown_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p-dropdown", 24);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", ctx_r2.disabledControls)("options", ctx_r2.listStates);
} }
function PortOfEntryLibraryComponent_input_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "input", 25);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("readonly", ctx_r3.disabledControls);
} }
function PortOfEntryLibraryComponent_div_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.getGlobalErrorMessages("REQUIRED"), " ");
} }
function PortOfEntryLibraryComponent_div_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r5.getGlobalErrorMessages("REQUIRED"), " ");
} }
class PortOfEntryLibraryComponent {
    constructor(
    // private cacheCountryService: CacheCountryService,
    formBuilder, 
    // private apiService: CountryApiService,
    apiService, changeDetectorRef, portEntryService, dynamicDialogConfig, toastr, store, stepStatusUpdatePayloadCostruction, cacheCountryService, referenceLibraryService) {
        this.formBuilder = formBuilder;
        this.apiService = apiService;
        this.changeDetectorRef = changeDetectorRef;
        this.portEntryService = portEntryService;
        this.dynamicDialogConfig = dynamicDialogConfig;
        this.toastr = toastr;
        this.store = store;
        this.stepStatusUpdatePayloadCostruction = stepStatusUpdatePayloadCostruction;
        this.cacheCountryService = cacheCountryService;
        this.referenceLibraryService = referenceLibraryService;
        this.observableSubscription$ = new Subject();
        this.checkStateMondatory = false;
        this.extrAblDocEvdCatg = [];
        this.listStates = [];
        this.listCountry = [];
        this.portEntryForm = this.formBuilder.group({
            countryCode: ['', [Validators.required]],
            state: [''],
            city: ['', [Validators.required]],
        });
    }
    ngOnInit() {
        combineLatest([
            this.store.pipe(select(getSubTaskDetails)),
            this.store.pipe(select(getStepDetails, { id: this.dynamicDialogConfig.data.stepId }))
        ]).pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            this.task = response[0];
            //   this.toggleControlsStatus();
            this.stepStatus = response[1].stepStatusDetails.stepStatusCode;
            this.stepDetails = response[1];
            if (this.stepStatus === 'COMPLETE' || this.stepStatus === 'NEW') {
                this.disabledControls = true;
            }
            else {
                this.disabledControls = false;
            }
        });
        this.cacheCountryService.getCountry().pipe(takeUntil(this.observableSubscription$)).subscribe();
        this.cacheCountryService.getCachedCountryList().pipe(takeUntil(this.observableSubscription$)).subscribe(data => {
            if (data.listCountries.length > 0) {
                this.listCountry = data.listCountries.filter(ele => {
                    return ele.countryCode === 'USA' || ele.countryCode === 'CAN';
                });
            }
            else {
                this.listCountry = [];
            }
        });
        this.getPort();
        this.portEntryForm.valueChanges.pipe(map$1(() => this.portEntryForm.dirty)).pipe(takeUntil(this.observableSubscription$)).subscribe(dirty => {
            if (dirty) {
                this.store.dispatch(new MarkDirtyFormAction({
                    dirty: true
                }));
            }
            else {
                this.store.dispatch(new MarkCleanFormAction({
                    dirty: false
                }));
            }
        });
    }
    // toggleControlsStatus() {
    //   this.disabledControls = this.stepDetails.stepStatusDetails.stepStatusCode === "COMPLETE" || this.stepDetails.stepStatusDetails.stepStatusCode === "SUBMIT" ? true : false;
    // }
    getPort() {
        this.portEntryService.getPort(this.dynamicDialogConfig.data.visatype, this.dynamicDialogConfig.data.caseType, this.dynamicDialogConfig.data.caseId).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (response.status === 200) {
                this.portData = response.data;
                this.handleCountryChange(this.portData.countryCode);
                this.portEntryForm.patchValue({
                    countryCode: this.portData.countryCode,
                    state: !this.portData.stateProvinceCode ? this.portData.stateProvinceName : this.portData.stateProvinceCode,
                    city: this.portData.city,
                });
                this.store.dispatch(new MarkCleanFormAction({
                    dirty: false
                }));
            }
        });
    }
    updateStepStatus(status) {
        this.store.dispatch(updateStepStatus({
            payload: this.stepStatusUpdatePayloadCostruction.payloadConstruction(this.stepDetails, status),
            subTaskId: this.stepDetails.taskId,
            stepId: this.dynamicDialogConfig.data.stepId,
            visaType: this.dynamicDialogConfig.data.caseType === 'I130' ?
                this.dynamicDialogConfig.data.caseType : this.dynamicDialogConfig.data.visatype
        }));
    }
    savePort() {
        let selectedState;
        let formData = this.portEntryForm.value;
        if (this.listStates.length > 0) {
            selectedState = this.listStates.find((element) => element.stateProvinceCode === formData.state);
        }
        else {
            selectedState = formData.state;
        }
        let payload = {
            "city": formData.city,
            "countryCode": formData.countryCode,
            "id": this.portData && this.portData.id ? this.portData.id : 0,
            "petitionId": this.dynamicDialogConfig.data.petitionId,
            "stateProvinceCode": this.listStates.length > 0 ? selectedState.stateProvinceCode : null,
            "stateProvinceName": this.listStates.length === 0 ? selectedState : null,
        };
        this.portEntryService.savePort(this.dynamicDialogConfig.data.visatype, this.dynamicDialogConfig.data.caseType, this.dynamicDialogConfig.data.caseId, payload).subscribe(res => {
            this.getPort();
            this.toastr.success(res.message, 'Success');
            // this.updateStepStatus('INPROGRESS');
        });
    }
    handleCountryChange(countryCode) {
        this.portEntryForm.controls['state'].reset();
        this.portEntryForm.controls['city'].reset();
        if (countryCode === 'USA') {
            this.portEntryForm.get('state').setValidators(Validators.required);
            this.checkStateMondatory = true;
        }
        else {
            this.portEntryForm.get('state').clearValidators();
            this.checkStateMondatory = false;
        }
        // this.portEntryForm.get('state').setValue(null);
        // this.portEntryForm.get('city').setValue(null);
        this.portEntryForm.get('state').updateValueAndValidity();
        this.referenceLibraryService.getStatesFromStore(countryCode)
            .pipe(take(1))
            .subscribe((states) => {
            if (states) {
                this.listStates = states;
                this.changeDetectorRef.markForCheck();
            }
            else {
                this.referenceLibraryService.getStatesFromApi(countryCode)
                    .pipe(take(1))
                    .subscribe((data) => {
                    this.listStates = data;
                    this.changeDetectorRef.markForCheck();
                });
            }
        });
    }
    getGlobalErrorMessages(error) {
        return errorUtils.errorMessages.get(error);
    }
}
PortOfEntryLibraryComponent.ɵfac = function PortOfEntryLibraryComponent_Factory(t) { return new (t || PortOfEntryLibraryComponent)(i0.ɵɵdirectiveInject(i1$1.FormBuilder), i0.ɵɵdirectiveInject(i2.APIConsulateAddress), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(PortOfEntryLibraryService), i0.ɵɵdirectiveInject(i4.DynamicDialogConfig), i0.ɵɵdirectiveInject(i5.ToastrService), i0.ɵɵdirectiveInject(i6.Store), i0.ɵɵdirectiveInject(i7.StepStatusUpdatePayloadService), i0.ɵɵdirectiveInject(i8.CacheCountryListService), i0.ɵɵdirectiveInject(i9.ReferenceLibraryService)); };
PortOfEntryLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: PortOfEntryLibraryComponent, selectors: [["lib-port-of-entry-library"]], decls: 30, vars: 13, consts: [[1, "fluid-container"], [1, "container-fuild"], [1, "row", "col-md-12", "mb-3"], [1, "sub-title"], [3, "formGroup"], [1, "row", "w-100"], [1, "col-12", "pl-0", "mb-3"], [1, "col-md-8", "input-disabled", "processing-dropdown"], [1, "label-cls", "required"], ["id", "countryCode", "formControlName", "countryCode", "optionLabel", "countryName", "optionValue", "countryCode", "placeholder", "select", 3, "options", "filter", "disabled", "onChange"], ["class", "invalid-message", 4, "ngIf"], [1, "col-12", "pl-0"], [1, "col-md-4", "form-group", "processing-dropdown"], [1, "label-cls"], ["class", "required", 4, "ngIf"], ["id", "stateProvinceCode", "formControlName", "state", "name", "country", "optionLabel", "stateProvinceName", "optionValue", "stateProvinceCode", "placeholder", "select", 3, "disabled", "options", 4, "ngIf"], ["class", "im-input mw-100", "id", "clientName", "formControlName", "state", "type", "text", "pInputText", "", "placeholder", "Enter", 3, "readonly", 4, "ngIf"], [1, "col-md-4", "form-group", "input-disabled"], ["id", "clientName", "formControlName", "city", "type", "text", "pInputText", "", "placeholder", "Enter", 1, "im-input", "mw-100", 3, "readonly"], [1, "row", "mt-4", "ml-3"], [1, "col-2", "px-0"], ["pButton", "", "type", "submit", "label", "Save", "icon", "pi pi-save", 3, "ngClass", "disabled", "click"], [1, "invalid-message"], [1, "required"], ["id", "stateProvinceCode", "formControlName", "state", "name", "country", "optionLabel", "stateProvinceName", "optionValue", "stateProvinceCode", "placeholder", "select", 3, "disabled", "options"], ["id", "clientName", "formControlName", "state", "type", "text", "pInputText", "", "placeholder", "Enter", 1, "im-input", "mw-100", 3, "readonly"]], template: function PortOfEntryLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "h5", 3);
        i0.ɵɵtext(4, "Port of Entry");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "form", 4);
        i0.ɵɵelementStart(6, "div", 5);
        i0.ɵɵelementStart(7, "div", 6);
        i0.ɵɵelementStart(8, "div", 7);
        i0.ɵɵelementStart(9, "label", 8);
        i0.ɵɵtext(10, " Country ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "p-dropdown", 9);
        i0.ɵɵlistener("onChange", function PortOfEntryLibraryComponent_Template_p_dropdown_onChange_11_listener($event) { return ctx.handleCountryChange($event.value); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(12, PortOfEntryLibraryComponent_div_12_Template, 2, 1, "div", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(13, "div", 11);
        i0.ɵɵelementStart(14, "div", 5);
        i0.ɵɵelementStart(15, "div", 12);
        i0.ɵɵelementStart(16, "label", 13);
        i0.ɵɵtext(17, "State");
        i0.ɵɵtemplate(18, PortOfEntryLibraryComponent_span_18_Template, 1, 0, "span", 14);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(19, PortOfEntryLibraryComponent_p_dropdown_19_Template, 1, 2, "p-dropdown", 15);
        i0.ɵɵtemplate(20, PortOfEntryLibraryComponent_input_20_Template, 1, 1, "input", 16);
        i0.ɵɵtemplate(21, PortOfEntryLibraryComponent_div_21_Template, 2, 1, "div", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(22, "div", 17);
        i0.ɵɵelementStart(23, "label", 8);
        i0.ɵɵtext(24, " City ");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(25, "input", 18);
        i0.ɵɵtemplate(26, PortOfEntryLibraryComponent_div_26_Template, 2, 1, "div", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(27, "div", 19);
        i0.ɵɵelementStart(28, "div", 20);
        i0.ɵɵelementStart(29, "button", 21);
        i0.ɵɵlistener("click", function PortOfEntryLibraryComponent_Template_button_click_29_listener() { return ctx.savePort(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("formGroup", ctx.portEntryForm);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("options", ctx.listCountry)("filter", false)("disabled", ctx.disabledControls);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.portEntryForm.get("countryCode").touched && (ctx.portEntryForm.get("countryCode").errors == null ? null : ctx.portEntryForm.get("countryCode").errors.required));
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngIf", ctx.checkStateMondatory);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.listStates.length > 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.listStates.length === 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.portEntryForm.get("state").touched && (ctx.portEntryForm.get("state").errors == null ? null : ctx.portEntryForm.get("state").errors.required));
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("readonly", ctx.disabledControls);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.portEntryForm.get("city").touched && (ctx.portEntryForm.get("city").errors == null ? null : ctx.portEntryForm.get("city").errors.required));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngClass", ctx.portEntryForm.invalid || ctx.disabledControls ? "btn-success button-width-icon-left mr-3 pl-4 pr-4 btn-success_disabled save-btn" : "btn-success button-width-icon-left mr-3  pl-4 pr-4 save-btn")("disabled", ctx.portEntryForm.invalid || ctx.disabledControls);
    } }, directives: [i1$1.ɵangular_packages_forms_forms_ba, i1$1.NgControlStatusGroup, i1$1.FormGroupDirective, i10.Dropdown, i1$1.NgControlStatus, i1$1.FormControlName, i11.NgIf, i1$1.DefaultValueAccessor, i12.InputText, i13.ButtonDirective, i11.NgClass], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PortOfEntryLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'lib-port-of-entry-library',
                templateUrl: './port-of-entry-library.component.html',
                styles: []
            }]
    }], function () { return [{ type: i1$1.FormBuilder }, { type: i2.APIConsulateAddress }, { type: i0.ChangeDetectorRef }, { type: PortOfEntryLibraryService }, { type: i4.DynamicDialogConfig }, { type: i5.ToastrService }, { type: i6.Store }, { type: i7.StepStatusUpdatePayloadService }, { type: i8.CacheCountryListService }, { type: i9.ReferenceLibraryService }]; }, null); })();

class PortOfEntryLibraryModule {
}
PortOfEntryLibraryModule.ɵfac = function PortOfEntryLibraryModule_Factory(t) { return new (t || PortOfEntryLibraryModule)(); };
PortOfEntryLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: PortOfEntryLibraryModule });
PortOfEntryLibraryModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[PrimengLibraryModule, ReactiveFormsModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(PortOfEntryLibraryModule, { declarations: [PortOfEntryLibraryComponent], imports: [PrimengLibraryModule, ReactiveFormsModule], exports: [PortOfEntryLibraryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PortOfEntryLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [PortOfEntryLibraryComponent],
                imports: [PrimengLibraryModule, ReactiveFormsModule
                ],
                exports: [PortOfEntryLibraryComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of port-of-entry-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { PortOfEntryLibraryComponent, PortOfEntryLibraryModule, PortOfEntryLibraryService };
//# sourceMappingURL=port-of-entry-library.js.map
